import initState from '@shared/init-state-v0.1.0';
import ky from 'ky';

export type Services =
	| false
	| Record<
			string,
			{
				isDefault?: boolean;
				nameForLabel: string;
				serviceVersion: { label: string; value: string }[];
				defaultServiceVersion: string;
			}
	  >;

export const getServices = async () => {
	// Ожидаем подключения к Kuzzle
	await initState('initialized');

	// Получаем параметры подключения к nodered из R
	const noderedCreds = R.params.creds?.find((i) => i.name === 'nodered')?.data;

	if (!noderedCreds) return;

	// Так как может не быть подключения к сети, при оффлайн режиме, то возвращаем пустой объект
	if (!R?.localData?.localDataReplicationEngine?.replicationStates?.isOnline) {
		return false;
	}

	// Ссылка для получения сервисов
	const servicesUrl = 'https://servicesmanager.services.p3.rolder.app/servicesManager_v1';

	const services = await ky
		.post(servicesUrl, {
			headers: {
				Authorization: `Basic ${btoa(`${noderedCreds.username}:${noderedCreds.password}`)}`,
			},
			body: null,
		})
		.json();

	// Получаем данные о сервисах
	return services as Services;
};
